import { Box, Divider, Paper, Typography } from '@mui/material';

import AccordionWrapper from 'components/ChecklistReport/AccordionWrapper';
import Stack from '@mui/material/Stack';
import ChecklistLogItem from '../ChecklistLogItem';
import useLocationsMap from 'utils/CustomHooks/useLocationsMap';
import { useMemo } from 'react';
import { MainContainer } from './style';

const Triggers = (props: any) => {
  const { reference, template, triggeredWorkflows } = props;
  const locationMap = useLocationsMap();

  const transformedData = useMemo(() => {
    return triggeredWorkflows?.map((trigger) => {
      return {
        ...trigger,
        matchedLogItems: trigger?.matchedLogItems?.map((item) => ({
          ...item,
          answers: { value: item?.answer },
          ...(item?.type === 'location' && {
            location: locationMap?.[item?.answer],
          }),
        })),
      };
    });
  }, [useLocationsMap, locationMap, triggeredWorkflows]);

  const getActionTitle = (type) => {
    if (type === 'CREATE_TASK_FROM_TEMPLATE') {
      return 'New Corrective Task Created';
    }

    if (type === 'CREATE_WORK_ORDER_FROM_TEMPLATE') {
      return 'New Work Order Created';
    }
  };

  return (
    <MainContainer className="mb-3" ref={reference} id="triggers">
      <AccordionWrapper
        headerName={
          <Stack direction="row" spacing={1} alignItems="center">
            <span>Triggers</span>
          </Stack>
        }
      >
        {transformedData?.map((trigger) => {
          return (
            <Paper className="paperBox" elevation={0}>
              <Box className="triggerCnt">
                <Typography className="title">Triggered By:</Typography>
                {trigger?.matchedLogItems?.map((item, index) => (
                  <div key={item.id}>
                    <ChecklistLogItem
                      isPublic={true}
                      logItem={item}
                      template={template}
                      showNotes={false}
                    />
                    {trigger?.matchedLogItems?.length !== index + 1 && (
                      <Divider className="separator" />
                    )}
                  </div>
                ))}
              </Box>

              {trigger?.triggeredActions?.map((action) => {
                return (
                  <Box className="actionCnt">
                    <Typography className="title">Action:</Typography>

                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Typography className="creationTitle">
                        {getActionTitle(action?.type)}
                      </Typography>
                      <Typography className="creationDescription">
                        {trigger?.resultingTasks?.[0]?.title}
                      </Typography>
                    </Stack>
                  </Box>
                );
              })}
            </Paper>
          );
        })}
      </AccordionWrapper>
    </MainContainer>
  );
};

export default Triggers;
